import React from 'react';

import './style.scss';

export default TableBody = ({ startingNum, endingNum, totalNum, page, totalPages, setPage }) => {

    let paginationDisplay = []
    for (let i = 1; i <= totalPages; i++) {
        paginationDisplay.push(
            <button 
                key={i}
                className={`pagination-button ${page === i ? 'pagination-active' : ''}`} 
                onClick={() => setPage(i)}
            >
                {i}
            </button>
        )
    }

    const startDisplay = startingNum + 1
    const endNum = endingNum + 1
    const endDisplay = endNum > totalNum ? totalNum : endNum

    return (
        <div className={`pagination-main`}>
            {paginationDisplay}
            <p className={`pagination-info`}>
                {`Displaying ${startDisplay} - ${endDisplay} of ${totalNum}`}
            </p>
        </div>
    )

}